<template>
<div class="noData">
    <div class="noData-img">
        <img class="img" :src="noData" alt="">
    </div>
    <div class="tip">{{noDataTip}}</div>

</div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    name: 'noData',
    data() {
        return {
            noData: require('common/images/mobile/img-noData.png')
        }
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {
    },
    computed: {
        ...mapGetters(['noDataTip'])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
@import "~common/scss/variable";
.noData {
    width: 7.5rem;
    text-align: center;
    font-size: 0.24rem;
    color: $c-gray;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .noData-img {
        .img {
            width: 1.69rem;
            height: 1.63rem;
        }
    }
    .tip {
        margin-top: 0.24rem;
        color: $c-grey;
    }

}
</style>
